'use client';

import Bugsnag from '@bugsnag/js';
// eslint-disable-next-line @alltrails/custom/react-imports
import React, { Fragment, useEffect } from 'react';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import { debugClient } from '@alltrails/core/utils/debugClient';
import setGlobalFetchHeaders from '@alltrails/core/utils/setGlobalFetchHeaders';
import GlobalErrorPage from '../components/GlobalErrorPage';

const plugin = Bugsnag.getPlugin('react');
const BugsnagErrorBoundary = plugin
  ? plugin.createErrorBoundary(React)
  : ({ children }: { children: React.ReactNode }) => <Fragment>{children}</Fragment>;

export default function RootClientLayout({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    debugClient({ localStorageKey: 'mugen.debug.useEffect' });
  }, []);

  const languageRegionCode = useLanguageRegionCode();
  setGlobalFetchHeaders({ languageRegionCode });

  debugClient({ localStorageKey: 'mugen.debug.layout' });

  return (
    // The ErrorBoundary automatically logs to Bugsnag. Please note that this error boundary handles page.tsx errors.
    // See https://nextjs.org/docs/app/getting-started/project-structure#component-hierarchy
    // Since we implement the Bugsnag ErrorBoundary here we don't use a separate error.tsx file.
    <BugsnagErrorBoundary
      // The GlobalErrorPage will log the error. The error may be obfuscated for security.
      // If the error has a "digest" property that will be logged by the GlobalErrorPage, and we can try to correlate that to the server logs.
      FallbackComponent={GlobalErrorPage}
    >
      {children}
      <div id="modalPortal" />
    </BugsnagErrorBoundary>
  );
}
